<div class="controls-container">
    <div class="controls-header">Combo Box</div>
    <div class="layout-gray" [style.padding]="'2px 4px'">
        <div class="controls-sub-header">Combo Box Single</div>
        <pm-combo-box
            [ItemsSource]="ItemsSource"
            ItemHeight="28"
            DisplayMemberPath="Name">
        </pm-combo-box>
    </div>
    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="layout-gray" [style.padding]="'2px 4px'">
        <div class="controls-sub-header">Combo Box Multiple</div>
        <pm-combo-box 
            [ItemsSource]="ItemsSource"
            [SelectionMode]="MultipleMode"
            ItemHeight="28"
            DisplayMemberPath="Name">
        </pm-combo-box>
    </div>  
    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-sub-header">Combo Box Single Theme</div>
    <div [style.padding]="'2px 4px'">
        <pm-combo-box
            [ItemsSource]="ItemsSource"
            ItemHeight="28"
            ComboBoxPanelClass="combo-box-panel-theme"
            ComboBoxButtonClass="button-icon-flat"
            DisplayMemberPath="Name">
        </pm-combo-box>
    </div>
    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->

    <div class="controls-sub-header">Combo Box Single No Removal With Default Value</div>
    <div [style.padding]="'2px 4px'">
        <pm-combo-box
            [ItemsSource]="ItemsSource"
            ItemHeight="28"
            ComboBoxPanelClass="combo-box-panel-theme"
            ComboBoxButtonClass="button-icon-flat"
            DisplayMemberPath="Name"
            ShowRemoveItem=false>
        </pm-combo-box>
    </div>

    <div class="controls-sub-header">Combo Box Longer List of Items</div>
    <div [style.padding]="'2px 4px'">
        <pm-combo-box 
            [ItemsSource]="BiggerItemsSource"
            ItemHeight="28"
            ComboBoxPanelClass="combo-box-panel-theme"
            ComboBoxButtonClass="button-icon-flat"
            DisplayMemberPath="Name"
            ShowRemoveItem=false>
        </pm-combo-box>
    </div>
    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/combo-box/combo-box.html